import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Tooltip from '@material-ui/core/Tooltip';
import teamStyle from "assets/jss/material-kit-react/views/landingPageSections/teamStyle.jsx";


import ComplexGrid from "../Sections/ComplexGrid";



import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import Grid from '@material-ui/core/Grid';


// var team1 = "https://cdn.nani.cool/web/onegrade/img/001.jpg";
// var team2 = "https://cdn.nani.cool/web/onegrade/img/002.jpg";
// var team3 = "https://cdn.nani.cool/web/onegrade/img/003.jpg";
var team1 = "https://cdn.nani.cool/web/onegrade/img/chat.png";
var team2 = "https://cdn.nani.cool/web/onegrade/img/pen.png";
var team3 = "https://cdn.nani.cool/web/onegrade/img/smartphone.png";

class TeamSection extends React.Component {
  render() {
    const { classes ,linkBtnData} = this.props;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgRoundedCircle,
      classes.imgFluid
    );

    function handleDownLoadClick(event) {

    };



    return (
      <div  className={classes.section}>
        <h2 className={classes.title}></h2>
        <div id={linkBtnData[2].DIV}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
              <Card plain>
                <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                  <img src={team1} alt="..." className={imageClasses} />
                </GridItem>
                <h4 className={classes.cardTitle} style={{ fontSize: 22 }}> 
                  下載閱卷APP，登入南一會員
                 {/* <br />
                  <small className={classes.smallTitle}>下載閱卷APP，登入南一會員</small> */}
                </h4>
                <CardBody>
                  <p className={classes.description} style={{ fontSize: 16 }}>
                    使用手機下載OneGrade閱卷APP，登入南一會員；尚未加入會員請先到南一官網完成註冊。
                  </p>
                </CardBody>
                <CardFooter className={classes.justifyCenter}>
                  <Button
                    color="#212121"
                    size="sm"
                    href="https://myaccount.nani.cool"
                    target="_blank">
                    <i />註冊南一會員中心
                </Button>
                </CardFooter>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Card plain>
                <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                  <img src={team2} alt="..." className={imageClasses} />
                </GridItem>
                <h4 className={classes.cardTitle} style={{ fontSize: 22 }}>
                  建立試卷名稱，掃描答案卡

                  {/* <br />
                  <small className={classes.smallTitle}>GitHub 送上新年大禮包，私有程式碼庫從今開始免費！</small> */}
                </h4>
                <CardBody>
                  <p className={classes.description} style={{ fontSize: 16 }}>
                    打開APP選擇「建立試卷」，輸入試卷名稱，掃描答案卡；再掃描學生的作答卡，成績自動匯入雲端成績系統。

                  </p>
                </CardBody>
                <CardFooter className={classes.justifyCenter}>
                  <Button
                    color="#212121"
                    size="sm"
                     href="https://cdn.nani.cool/app/OneGrade_ans.pdf"
                    target="_blank">
                    <i />下載國中小答案卡
                </Button>


                {/* <Button
                    color="#FF0000"
                    style={{"background-color":"#FF0000"}}
                    size="sm"
                     href="https://cdn.nani.cool/app/ReadUpdate/107%E4%B8%8B%E9%96%B1%E5%8D%B7%E5%91%BD%E9%A1%8C%E6%9B%B4%E6%96%B0%E8%BB%9F%E9%AB%94_%E4%BD%BF%E7%94%A8%E8%AA%AA%E6%98%8E.docx"
                    target="_blank">
                    <i />更新說明
                </Button> */}
                <Button
                    color="#212121"
                    size="sm"
                     href="https://cdn.nani.cool/app/OneGrade_ans1.pdf"
                    target="_blank">
                    <i />下載高中答案卡
                </Button>


{/* 
                <Tooltip disableFocusListener disableTouchListener title="COMING SOON">
                  <Button
                    color="#212121"
                    size="sm"
                    // href="https://trans.nani.com.tw/NaniWeb/"
                    target="_blank">
                    <i />題庫更新
                </Button> 
                </Tooltip>*/}


                </CardFooter>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Card plain>
                <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                  <img src={team3} alt="..." className={imageClasses} />
                </GridItem>
                <h4 className={classes.cardTitle} style={{ fontSize: 22 }}>
                  登入成績管理系統，分析考試結果

                  {/* <br />
                  <small className={classes.smallTitle}>Windows 10大更新要來了：會再吃掉你7GB空間</small> */}
                </h4>
                <CardBody>
                  <p className={classes.description} style={{ fontSize: 16 }}>
                    登入雲端成績系統查詢批改結果，系統可以分析錯題與學生作答狀況；可列印報表、匯出Excel檔。

                  </p>
                </CardBody>
                <CardFooter className={classes.justifyCenter}>
                  {/* <Button
                    color="#212121"
                    size="sm"
                    // href="https://trans.nani.com.tw/NaniWeb/"
                    target="_blank">
                    <i />雲端成績系統
                </Button> */}
                </CardFooter>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
        
        <div id={linkBtnData[3].DIV}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}
              container
              spacing={0}
              align="center"
              justify="center"
            >
              <Card className={classes.card}>
                <CardActionArea>
                  <CardMedia
                    component="img"
                    alt=""
                    className={classes.media}

                    image="https://cdn.nani.cool/web/onegrade/img/001.png"
                    title=""
                  />
                </CardActionArea>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={6}
              container
              spacing={0}
              align="center"
              justify="center" >
              <Card className={classes.card} >
                <CardActionArea> </CardActionArea>
                <CardMedia>  </CardMedia>
                <CardContent>
                  <Typography className={classes.title} color="textSecondary" gutterBottom style={{ fontSize: 48 }}>
                    最易使用無負擔
                  </Typography>
                  <Typography className={classes.pos} color="textSecondary" style={{ fontSize: 28 }}>
                    結合題庫光碟出題，支援100道題目，選題匯出很easy。
                  </Typography>
                </CardContent>
                <CardActions>
                </CardActions>
              </Card>
            </GridItem>
          </GridContainer>
     
          <GridContainer>
 

            <GridItem xs={12} sm={12} md={6}
              container
              spacing={0}
              align="center"
              justify="center"
            >
              <Card className={classes.card}>
                <CardActionArea>
                  <CardMedia
                    component="img"
                    alt=""
                    className={classes.media}

                    image="https://cdn.nani.cool/web/onegrade/img/002.png"
                    title=""
                  />
                </CardActionArea>
              </Card>
            </GridItem>
              <GridItem xs={12} sm={12} md={6}
              container
              spacing={0}
              align="center"
              justify="center" >
              <Card className={classes.card} >
                <CardActionArea> </CardActionArea>
                <CardMedia>  </CardMedia>
                <CardContent>
                  <Typography className={classes.title} color="textSecondary" gutterBottom style={{ fontSize: 48 }}>
                  模擬大考答案卡          
                  </Typography>
                  <Typography className={classes.pos} color="textSecondary" style={{ fontSize: 28 }}>
                  答案卡格式與大考相同，讓學生提早習慣大考畫卡方式，老師也可以製作自己的模擬試卷。
                  </Typography>
                </CardContent>
                <CardActions>
                </CardActions>
              </Card>
            </GridItem>
          </GridContainer>
        
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}
              container
              spacing={0}
              align="center"
              justify="center"
            >
              <Card className={classes.card}>
                <CardActionArea>
                  <CardMedia
                    component="img"
                    alt=""
                    className={classes.media}

                    image="https://cdn.nani.cool/web/onegrade/img/003.png"
                    title=""
                  />
                </CardActionArea>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={6}
              container
              spacing={0}
              align="center"
              justify="center" >
              <Card className={classes.card} >
                <CardActionArea> </CardActionArea>
                <CardMedia>  </CardMedia>
                <CardContent>
                  <Typography className={classes.title} color="textSecondary" gutterBottom style={{ fontSize: 48 }}>
                  最人性化的操作流程
                  </Typography>
                  <Typography className={classes.pos} color="textSecondary" style={{ fontSize: 28 }}>
                  APP開啟自動感應答案卡，無需按拍照鈕也能快速一張接一張掃描，考試結果輕鬆入庫。
                  </Typography>
                </CardContent>
                <CardActions>
                </CardActions>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(teamStyle)(TeamSection);



// WEBPACK FOOTER //
// ./src/views/HomePage/Sections/TeamSection.jsx